import Image from 'next/image';
import Link from 'next/link';

import Watermark from '@/shared/assets/article-image-overlay.svg?svg';
import { Article as ArticleType } from '@/shared/types';
import { Box, Button, Text } from '@/shared/ui';
import { BackButton } from '../BackButton';
import { ArticleDate } from './ArticleDate';
import { Controls } from './Controls';
import { renderContent } from './renderContent';
import { Viewed } from './Viewed';
import styles from './Article.module.css';

type ArticleProps = {
  categorySlug: string;
} & ArticleType;

export const Article = ({
  id,
  publish_date,
  title,
  short_description,
  tags,
  categorySlug,
  content,
  rubric_ids,
  cover_url,
}: ArticleProps) => {
  return (
    <div className={styles.article}>
      <div className={styles.header}>
        <BackButton fallback={`/${categorySlug}`} />
        <div className={styles.info}>
          <Text
            className={styles.rubrics}
            fontSize={12}
            fontWeight={600}
            lineHeight="140%"
            letterSpacing={0.024}
            color="neutral-4-100"
          >
            {rubric_ids?.reduce(
              (acc, item, idx) => `${acc}${idx !== 0 ? ',' : ''} ${item.name}`,
              ''
            )}
          </Text>
          <span>·</span>
          <ArticleDate date={publish_date ?? ''} />
        </div>
      </div>

      <div className={styles.body}>
        <Text color="black" className={styles.title} variant="secondary">
          {title}
        </Text>
        <div className={styles.container}>
          <div className={styles.coverImageWrapper}>
            <Image src={cover_url ?? ''} alt={title ?? ''} fill />
            <Watermark className={styles.imageOverlay} />
          </div>

          {id && <Controls articleId={id} description={short_description} />}

          <Text
            color="black"
            fontFamily="Merriweather"
            className={styles.description}
          >
            {short_description}
          </Text>

          {content && (
            <div className={styles.content}>{renderContent(content)}</div>
          )}

          {id && <Controls articleId={id} description={short_description} />}

          {tags && tags?.length > 0 && (
            <Box
              display="flex"
              flexDirection="column"
              gap={12}
              paddingBottom={20}
            >
              <Text
                fontSize={14}
                fontWeight={700}
                lineHeight={20}
                color="neutral-4-100"
                letterSpacing={-0.154}
              >
                Теги
              </Text>
              <Box display="flex" gap={4} flexWrap="wrap">
                {tags?.map((tag) => (
                  <Button asChild key={tag.slug}>
                    <Link href={`/tag/${tag.slug}`}>{tag.name}</Link>
                  </Button>
                ))}
              </Box>
            </Box>
          )}
        </div>

        {id && <Viewed id={id} />}
      </div>
    </div>
  );
};
